var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from "vue-property-decorator";
import Card from "../Components/Card.vue";
import Rate from "../Components/Rate.vue";
import { now, utc } from "moment";
var Rates = /** @class */ (function (_super) {
    __extends(Rates, _super);
    function Rates() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Rates.prototype, "now", {
        get: function () {
            return utc(now());
        },
        enumerable: true,
        configurable: true
    });
    Rates.prototype.badge = function (source) {
        if (source && source.startDate && this.now.isBefore(source.startDate))
            return "Not Yet Open";
        if (source && source.endDate && this.now.isAfter(source.endDate))
            return "Closed";
        if (source && source.isFull === true)
            return "Full";
        return undefined;
    };
    Object.defineProperty(Rates.prototype, "allActivities", {
        get: function () {
            return [this.tuition, this.housing, this.childrensProgram].concat(this.otherActivites);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rates.prototype, "otherActivites", {
        get: function () {
            return [this.sessions, this.extraCurricular]
                .flatten(function (p) { return p.children; });
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Prop({ type: String, default: "dddd, LL" })
    ], Rates.prototype, "dateFormat", void 0);
    __decorate([
        Prop({ type: Object })
    ], Rates.prototype, "housing", void 0);
    __decorate([
        Prop({ type: Object })
    ], Rates.prototype, "tuition", void 0);
    __decorate([
        Prop({ type: Object })
    ], Rates.prototype, "sessions", void 0);
    __decorate([
        Prop({ type: Object })
    ], Rates.prototype, "extraCurricular", void 0);
    __decorate([
        Prop({ type: Object })
    ], Rates.prototype, "childrensProgram", void 0);
    Rates = __decorate([
        Component({
            name: "Rates",
            components: {
                Card: Card,
                Rate: Rate
            }
        })
    ], Rates);
    return Rates;
}(Vue));
export default Rates;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Colloquium/Rates.vue
// module id = 891
// module chunks = 0